export const spacing = {
  spacing_xs: 15,
  spacing_s: 30,
  spacing_m: 45,
  spacing_l: 60,
  spacing_xl: 75,
  spacing_xxl: 90,
};
